import { ReactNode } from "react";

export type SuggestedContentProps = {
  children: ReactNode;
};

export function SuggestedContent(props: SuggestedContentProps) {
  return (
    <div className="flex flex-col">
      <h4 className="font-bold">More like this...</h4>
      <div className="flex flex-1 flex-col gap-4 lg:flex-row">
        {props.children}
      </div>
    </div>
  );
}

export default SuggestedContent;
